import { Component, OnInit } from '@angular/core';
import { ScaffoldDialogRef } from '@app/framework/dialog/scaffold-dialog.service';
import { NotificationsService } from '@services/notifications.service';
import { TranslationService } from '@services/translation.service';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-translate-update',
    templateUrl: './translate-update.component.html',
    styleUrls: ['./translate-update.component.scss'],
    standalone: false
})
export class TranslateUpdateComponent implements OnInit {
  sourceLanguage$: any;
  hasLoaded: boolean;
  hasErrors: boolean;
  translation: any;
  keys = [];
  selectedKey;
  selectedKeyValue;
  selectedOperation = 'add';
  newContent = '';
  newKey = '';
  isUpdating: boolean = false;

  constructor(
    private dialogRef: ScaffoldDialogRef,
    private translationService: TranslationService,
    private notifications: NotificationsService
  ) {}

  ngOnInit(): void {
    this.sourceLanguage$ = this.translationService.getSourceLanguage$().pipe(
      tap(({ hasErrors, hasLoaded, translation }) => {
        this.hasErrors = hasErrors;
        this.hasLoaded = hasLoaded;
        this.translation = translation;
        if (!hasErrors && translation && Object.keys(translation).length) {
          this.keys = Object.keys(translation).sort((a, b) =>
            a > b ? 1 : a < b ? -1 : 0
          );
          this.selectedKey =
            this?.['data']?.initialSelectedKey || this.keys?.[0];
          this.selectedKeyValue = translation?.[this.selectedKey];
        }
      })
    );
  }
  updateSelectedKeyValue() {
    this.selectedKeyValue = this.translation[this.selectedKey];
  }

  updateKey() {
    this.isUpdating = true;
    this.translationService
      .updateKey$(this.selectedKey, this.selectedKeyValue)
      .subscribe(response => {
        const hasError = response?.error || response?.errorMessage;
        const message = hasError ? 'Error Updating Key' : 'Updated Key';
        this.notifications.popNotification('', message);
        this.isUpdating = false;
      });
  }

  addKey() {
    this.newKey = this.newKey.toLowerCase().trim().replace(/\s+/g, '_');
    if (this.keys.includes(this.newKey))
      return this.notifications.popNotification('', 'Duplicate Key');

    this.isUpdating = true;
    const that = this;
    this.translationService
      .addKey$(this.newKey, this.newContent.trim())
      .subscribe(response => {
        const message =
          response?.error || response?.errorMessage || !response?.[0]?.rowCount
            ? 'Error Adding Key'
            : 'Added Key';
        this.notifications.popNotification('', message);

        if (response.error || response.errorMessage) {
          this.isUpdating = false;
        } else {
          that.dialogRef.close({ key: this.newKey });
        }
      });
  }
}
